export const MRC_LINK = 'https://instacart-ads.knowledgeowl.com/help/mrc-accreditation'
